const LibraryMaterialFilters = [
  {
    name: 'Library',
    searchState: 'always',
    pages: ['LibraryMaterial'],
    filterName: 'house',
    options: [
      {
        name: 'House of Commons',
        hash: 'commons-library',
        filterValue: 'Commons',
      },
      {
        name: 'House of Lords',
        hash: 'lords-library',
        filterValue: 'Lords',
      },
    ],
  },
  {
    name: 'Type',
    searchState: 'always',
    pages: ['LibraryMaterial'],
    filterName: 'articleTypes',
    options: [
      {
        name: 'Research Briefing',
      },
      {
        name: 'Constituency Casework',
      },
      {
        name: 'Data Dashboard',
      },
      {
        name: 'Insight',
      },
      {
        name: 'Debate Pack',
      },
      {
        name: 'In Focus',
      },
    ],
  },
];

export default LibraryMaterialFilters;
